import React from 'react';
import { getIn } from 'seamless-immutable';
import styled from 'styled-components';
import { withConfig } from '@catalogo/core-connect/config';

export const getStampEvent = (currentSku, config) => {
  const stampName = getIn(currentSku, ['offers', 'result', 0, 'stamps', 'events', 0]);

  if (!stampName) {
    return null;
  }

  return `https://images-americanas.b2w.io/selob2c/${config?.brandNameLower}/${stampName}.png`;
};

export const StampEvent = ({ currentSku, config }) => {
  const stampEvent = getStampEvent(currentSku, config);

  if (!stampEvent) {
    return null;
  }

  return (
    <Wrapper>
      <img src={stampEvent} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  left: 10px;
  z-index: 1;

  & img {
    max-width: 100%;
  }
`;

export default withConfig(StampEvent);
